module.exports = {
	bg: {
		app: {
			title: 'Семейна образователна мрежа'
		},
		label: {
			first_name: 'Име',
			fathername: 'Баща',
			mothername: 'Майка',
			email: 'Email',
			book_title: 'Заглавие',
			book_description: 'Описание',
			book_categories: 'Категории',
			book_language: 'Език',
			book_author: 'Автор',
			book_publisher: 'Издателство',
			book_status: 'Статус',
			book_taker_internal: 'При семейство от мрежата',
			book_taker_external: 'При семейство, което не е в мрежата',
			link_title: 'Заглавие',
			link_description: 'Описание',
			link_categories: 'Категории',
			link_language: 'Език',
			link_link: 'Връзка',
			topic_title: 'Заглавие',
			topic_section: 'Секция',
			topic_categories: 'Категории',
			topic_text: 'Съобщение',
			category_name: 'Име',
			category_scope: 'Използване',
			category_parent: 'Над-категория',
			section_name: 'Име',
			section_description: 'Описание',
			section_color: 'Цвят',
			section_paid: 'Платена',
			family_name: 'Име на семейството',
			family_people: 'Членове на семейството',
			family_parents: 'Родители',
			family_children: 'Деца',
			person_name: 'Име',
			person_interests: 'Интереси',
			person_photo: 'Снимка',
			person_sex: 'Пол',
			person_birth_year: 'Година на раждане',
			person_add: 'Добавяне',
			family_location: 'Контакт',
			family_country: 'Страна',
			family_state: 'Област',
			family_city: 'Град/село',
			family_social: 'Контакти в социалните мрежи',
			family_about_us: 'Домашно образование',
			family_experience: 'Опит (години)',
			family_methods: 'Методи',
			family_admin_note: 'Бележка за модератора',
			family_interests: 'Интереси (разделени със запетая)',
			family_about: 'Информация',
			family_social_network: 'Социална мрежа',
			family_social_url: 'Адрес (URL)',
			invited_by: 'Поканени сте от',
			accept: 'Приеми',
			decline: 'Откажи',
			forum_reply: 'Отговор',
			forum_edit: 'Редакция',
		},
		title: {
			dashboard: 'Начало',
			events: 'История',
			familyProfile: 'Семеен профил',
			familyProfileEdit: 'Семеен профил: Редактиране',
			familyList: 'Семейства',
			books: 'Книги',
			bookNew: 'Нова Книга',
			bookEdit: 'Книга: Редактиране',
			bookView: 'Книга',
			materials: 'Учебни материали',
			materialView: 'Учебен Материал',
			materialNew: 'Нов Учебен Материал',
			materialEdit: 'Редактиране на Учебен Материал',
			links: 'Връзки',
			linkNew: 'Нова Връзкa',
			linkView: 'Връзка',
			linkEdit: 'Редактиране на Връзкa',
			discussionNew: 'Нова Тема',
			registration: 'Регистрация на семеен профил',
			invitation: 'Покана за приесъединяване към мрежата',
			calendar: 'Календар',
			plans: 'Планове на уроци',
			planEdit: 'Планове на уроци: Редактиране',
			planNew: 'Нов план на уроци',
			categoryList: 'Категории',
			categoryNew: 'Категория: Нова',
			categoryEdit: 'Категория: Редактиране',
			categoryView: 'Категория',
			sectionList: 'Секции',
			sectionNew: 'Нова Секция',
			sectionEdit: 'Редактиране на Секция',
			familyRequests: 'Регистрации',
			familyRequest: 'Регистрация',
			discussions: 'Дискусии',
			theme: 'Тема'
		},
		status: {
			error: 'Грешка',
			book_undefined: 'Грешка',
			book_available: 'Налична',
			book_unavailable: 'Не e налична',
			book_requested: 'Поискана',
			book_taken: 'Заета',
			family_new: 'Ново',
			family_edited: 'Променено',
			family_rejected: 'Неодобренo'
		}
	}
};



// WEBPACK FOOTER //
// ./src/lang/locales.js